module.exports = "pegasus_template/assets/themelp1/simple/106.png";